package com.cs.ejobin.app

import com.cs.ejobin.model.Subscription
import com.cs.ejobin.model.UserProfile
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

data class SessionState(
    val isLoggedIn: Boolean = false,
    val user: UserProfile? = null,
    val subscription: Subscription = Subscription.None
) {
    // ✅ Paiement désactivé : on garde la propriété pour compat, mais elle ne sert plus au gating.
    val hasActiveSubscription: Boolean get() = subscription.isActive

    // ✅ Paiement désactivé : tout utilisateur connecté a accès à l'annuaire
    val hasDirectoryAccess: Boolean get() = isLoggedIn
}

class AppSession {
    private val _state = MutableStateFlow(SessionState())
    val state: StateFlow<SessionState> = _state.asStateFlow()

    fun setLoggedIn(user: UserProfile, subscription: Subscription) {
        _state.value = SessionState(isLoggedIn = true, user = user, subscription = subscription)
    }

    fun updateUser(user: UserProfile) {
        _state.value = _state.value.copy(user = user)
    }

    fun updateSubscription(subscription: Subscription) {
        _state.value = _state.value.copy(subscription = subscription)
    }

    fun logout() {
        _state.value = SessionState()
    }
}